module.exports = __webpack_public_path__ + "static/media/city.b26f8c44.mp3";